<template>
  <nx-content-selector
    :allowNonPublished="allowNonPublished"
    :label="label"
    :type="type"
    :additional-filters="additionalFilters"
    :additional-filters-params="additionalFiltersParams"
    :excluded-content-ids="excludedContentIds"
    :allowEditItems="allowEditItems"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    :value="value"
    v-validate:value="validation"
    :error-messages="errorMessages"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
    :title-length="titleLength"
    :open-modal-editor="openModalEditor"
    :wizard="wizard"
    :searcherEntity="searcherEntity"
  ></nx-content-selector>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxContentSelector from '@/modules/content/selector/Selector';


/**
 * Content selector module.
 *
 * @property {[]} [type] The content type that can be selected. They will added as a filter
 *                               in when searching for contents.
 * @property {string} [identifier] String to use as identifier for this module.
 * @property {[]} [value] Array of initial selected contents.
 */
export default {
  name: 'nx-content-form-selector',
  mixins: [FormElement],
  components: {
    NxContentSelector,
  },
  props: {
    additionalFilters: {
      type: Object,
      default: () => ({}),
    },
    additionalFiltersParams: {
      type: Object,
      default: () => ({}),
    },
    allowNonPublished: {
      type: Boolean,
      default: false,
    },
    type: {
      type: [String, Array],
    },
    value: {
      type: [Object, String, Number],
    },
    titleLength: {
      type: [Number],
      default: 0,
    },
    allowEditItems: {
      type: Boolean,
      default: () => true,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    excludedContentIds: {
      type: Array,
      default: () => ([]),
    },
    openModalEditor: {
      type: Boolean,
    },
    wizard: {
      type: [String, Array],
    },
    searcherEntity: {
      type: String,
      default: 'content',
    },
  },
  methods: {
    onDefault(defaultValue) {
      this.onInput(defaultValue);
      this.onBlur(defaultValue);
    },
    onInput(content) {
      const value = content && content.id ? content.id : null;
      this.$parentForm.updateField(this.name, value, content);
      this.$emit('input', value, content || null);
    },
    onBlur(content) {
      this.flags.focused = false;
      this.$emit('blur', content);
    },
  },
};
</script>
